import { parseISO } from 'date-fns';
import ReactDOM from 'react-dom';
import { TimeElement } from '../../TimeElement/TimeElement';
import { capitalizeFirstLetter } from '../../Util';
import formatCloseRelative from '../../Util/formatCloseRelative';
import { type RoadConditionSectionProperties } from '../Sources/RoadConditionSection';

export default function RoadCondition(properties: RoadConditionSectionProperties): HTMLElement {
    const aDiv = document.createElement('div');
    aDiv.className = 'tooltip';
    ReactDOM.render(
        <>
            <strong>{properties.name}</strong>

            {properties.status && properties.conditionText ? (
                <>
                    <table>
                        <tbody>
                            {!!properties.warning?.length && (
                                <tr>
                                    <td className="bold label-cell">Varning: </td>
                                    <td>{capitalizeFirstLetter(properties.warning.join(', ').toLowerCase())}</td>
                                </tr>
                            )}
                            <tr>
                                <td className="bold label-cell">Väglag: </td>
                                <td>
                                    {capitalizeFirstLetter(properties.conditionText)}
                                    {!!properties.conditionInfo?.length && `, ${properties.conditionInfo.join(', ').toLowerCase()}`}
                                </td>
                            </tr>
                            {!!properties.cause?.length && (
                                <tr>
                                    <td className="bold label-cell">Orsak: </td>
                                    <td>{capitalizeFirstLetter(properties.cause.join(', ').toLowerCase())}</td>
                                </tr>
                            )}
                            {!!properties.measurement?.length && (
                                <tr>
                                    <td className="bold label-cell">Åtgärd: </td>
                                    <td>{capitalizeFirstLetter(properties.measurement.join(', ').toLowerCase())}</td>
                                </tr>
                            )}
                            <tr>
                                <td className="bold label-cell">Giltig från: </td>
                                <td>
                                    {properties.startTime ? (
                                        <TimeElement date={parseISO(properties.startTime)}>
                                            {capitalizeFirstLetter(formatCloseRelative(parseISO(properties.startTime)))}
                                        </TimeElement>
                                    ) : (
                                        'Ingen uppgift'
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <dl className="tooltip-details">
                        <dt>Källa:</dt>
                        <dd>Trafikverket</dd>
                    </dl>
                </>
            ) : (
                <p>Aktuell data saknas</p>
            )}
        </>,
        aDiv,
    );
    return aDiv;
}
